import { ChartBinSize, ChartDataMode, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';

import { IOTS_UPTIME_CHART_ENDPOINT } from '../iot-chart-endpoints';

export const IOTS_UPTIME_BY_TYPE_LIST_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.IOTS_UPTIME_BY_TYPE_LIST,
    chartType: ChartRendererType.LIST,
    endpoint: IOTS_UPTIME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD },
        { key: ChartQueryParam.DATA_MODE, value: ChartDataMode.PERCENTAGE }
    ],
    groupBy: ChartQueryParam.TYPE
};
